import { createI18n } from 'vue-i18n'

import id from './id.json'
import en from './en.json'
import zh from './zh.json'
import ar from './ar.json'

const messages = {
  id: id,
  en: en,
  zh: zh,
  ar: ar
}

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('lang') || 'id',
  fallbackLocale: 'id',
  messages
})

export default i18n